import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";

const PARTNERS = [
  {
    name: "RS-Montagebau",
    logo: "/bilder/partner-rs.png",
    role: "Montagepartner",
    desc: "Verlässlicher Partner bei Großprojekten und Sanierungen.",
    url: "https://www.rs-montagebau.de",
  },
  {
    name: "EKO-OKNA",
    logo: "/bilder/partner-eko.png",
    role: "Systemlieferant",
    desc: "Europäischer Hersteller hochwertiger Fenster-, Tür- und Rollladensysteme – die Basis für unsere Produktqualität.",
    url: "https://ekookna.de",
  },
];

export const Partners = () => (
  <section id="partner" data-testid="partners-section" className="bg-[#e9e7e2] py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="mb-14">
        <SectionHeading
          testid="partners"
          eyebrow="Partner"
          title="Starke Partner an unserer Seite."
          text="Wir arbeiten nur mit Partnern, deren Qualitätsanspruch dem unseren entspricht."
        />
      </div>
      <div data-testid="partners-grid" className="grid md:grid-cols-2 gap-6">
        {PARTNERS.map((p, i) => (
          <motion.div
            key={p.name}
            data-testid={`partner-card-${i}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="group bg-[#23272b] rounded-2xl overflow-hidden hover:bg-[#1e2226] transition-colors duration-300"
          >
            <div className="bg-white px-8 py-8 flex items-center justify-center">
              <img src={p.logo} alt={`${p.name} Logo`} className="h-24 sm:h-28 w-auto max-w-full object-contain" />
            </div>
            <div className="p-9 sm:p-10 flex flex-col min-h-[230px]">
              <div>
                <p className="font-display text-xs tracking-[0.24em] uppercase text-white/40 mb-5">{p.role}</p>
                <h3 className="font-display font-bold text-white text-2xl sm:text-3xl">{p.name}</h3>
                <p className="text-white/60 text-sm sm:text-base leading-relaxed mt-4">{p.desc}</p>
              </div>
              <a
                data-testid={`partner-link-${i}`}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center gap-2 font-display font-medium text-sm text-white/70 hover:text-white transition-colors duration-200"
              >
                Zur Website von {p.name}
                <ArrowUpRight size={15} className="text-[#e2001a] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
